import React, { Fragment, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "react-pro-sidebar";
import { IconButton, Grid, Stack, Box, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import Collapse from "@mui/material/Collapse";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseIcon from "@mui/icons-material/Close";
import TkTitle from "../../atoms/TkTitle";
import TkButton from "../../atoms/TkButton";
import { facilitiesAndOtherProcedures, standardMenu } from "./parts";
import "./_style.scss";
import SCRC090002 from "../../../pages/SCRC090002";
import { BusinessContext } from "../../../context/businessContext";
import { GlobalContext } from "../../../context/globalContext";
import { useConcatRoutes } from "../../../routes/router";
import _ from "lodash";

/**
 * システムメニュー
 * ヘッダーに表示するハンバーガーメニュー
 * @return TkMenuForDaikou
 */
export const TkMenuForDaikou: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [threadOpen, setThreadOpen] = useState(false);

  const { state, setState } = useContext(GlobalContext);
  const { setState: setBussinessState } = useContext(BusinessContext);

  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (page: any, pageObj: any) => {
    const { path, param, setBusinessType } = pageObj;

    let wantToSetInRouterList = [
      {
        href: "/SCRD310001",
        title: "代行者ホーム",
      },
    ];

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const routers = useConcatRoutes();

    const router = routers.find((r) => r.path === path);
    const newItem = _.cloneDeep(router);

    wantToSetInRouterList[1] = {
      title: newItem?.meta?.title as string,
      href: path as string,
    };

    setBussinessState({
      common: {
        businessType: setBusinessType ?? "",
      },
    });

    navigate(path, { state: { ...param, wantToSetInRouterList } });

    setIsOpen(false);
    setState({ ...state, chatOpen: page === "チャットボットに質問する" });
    setThreadOpen(page === "機構職員に連絡する");
  };

  const renderMenuItems = (menuItems: any[], noBorder?: boolean) => {
    return menuItems.map((menu, key) => (
      <Fragment key={key}>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Box className={`top-hamMenu-text ${noBorder && "hideBorder"}`}>
            {menu.icon}
            <Typography>{menu.name}</Typography>
          </Box>
        </Collapse>
        {menu.options.map((submenu: any, index: any) => (
          <MenuItem
            key={index}
            className={`sub-hamMenu-text ${
              location.pathname === submenu.path ? "active" : ""
            }`}
            data-testid="TkMenuForDaikouLink"
            component={
              <Box onClick={() => handleClick(submenu.name, submenu)} />
            }
            icon={submenu.icon}
            title={submenu.name}
          >
            <Typography>{submenu.name}</Typography>
          </MenuItem>
        ))}
      </Fragment>
    ));
  };

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        title="システムメニュー一覧はこちら"
        onClick={() => setIsOpen(true)}
        data-testid="TkMenuForDaikouIconButton"
      >
        <MenuOutlinedIcon />
      </IconButton>
      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="TkMenuForDaikouModal"
      >
        <Grid
          container
          spacing={1}
          alignContent="flex-start"
          className="TkMenuForDaikouStyle"
        >
          <Grid item xs={12} className="TkMenuForDaikouHeader">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <TkTitle>退職手当共済システムメニュー</TkTitle>
              <TkButton
                variant="contained"
                onClick={() => setIsOpen(false)}
                size="small"
              >
                <CloseIcon />
                <Typography className="closeButtonText">閉じる</Typography>
              </TkButton>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} pr={1} pl={1}>
            <Menu>{renderMenuItems(standardMenu)}</Menu>
          </Grid>

          <Grid item xs={12} sm={6} pr={1}>
            <Grid container>
              <Grid item xs={12} sm={12} pr={1}>
                <Menu>{renderMenuItems(facilitiesAndOtherProcedures)}</Menu>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>

      <SCRC090002 open={threadOpen} onClose={() => setThreadOpen(false)} />
    </>
  );
};

export default TkMenuForDaikou;
